export default __webpack_public_path__ + "static/media/mushroomhead.bbea435c.jpg";